/* eslint-disable max-len */
export default {
  // baseUrl: "https://api-dev.autonet.co.in/api/",
  // baseUrl: "http://nalanda.d-crm.in/api/",
  baseUrl: "https://loi-api.autonet.co.in/api/",
  googleMapsApiKey: "AIzaSyD4WSUmy8f1tDcbik6CrjF4QSwLi5Cx2vw",
};
